import React from 'react';
import {connect} from "react-redux";
import Pagination from 'react-js-pagination';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Select from 'react-select';
import { contains, isEqual } from 'underscore'

import AreaControlFilter from './AreaControlFilter';
import ItemList from './ItemList';
import ResultCount from '../../components/List/ResultCount';

import {
    updateQuery,
    updateModuleFilter,
    changePage,
    setPageSize,
    updateReplenishmentStatusFilter,
    fetchAreaControlledItems,
    fetchModules,
    updateStockStatusFilter,
    updateRefillStatusFilter,
    toggleAreaControl,
    disableAreaControl,
    enableAreaControl,
    disapproveForRefill,
    approveForRefill,
    forceReplenishment,
    updateSortProperty,
    updateMinimumStockQuantity,
    removeFromAreaControl
} from './reducer';

import {buildCsvDownloadUrl} from '../../services/AreaControlModule';
import RemoveFromAreaControlModal from "./RemoveFromAreaControlModal";

export class AreaControlOverviewManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            dropdownMenuOpen: false,
            removeFromAreaControlModalVisible: false,
            selectedItems: {},
            showSidebar: true
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggleItemSelection = this.toggleItemSelection.bind(this);
        this.clearSelectedItems = this.clearSelectedItems.bind(this);
        this.toggleDropDownMenu = this.toggleDropDownMenu.bind(this);
        this.enableAreaControl = this.enableAreaControl.bind(this);
        this.disableAreaControl = this.disableAreaControl.bind(this);
        this.disapproveForRefill = this.disapproveForRefill.bind(this);
        this.approveForRefill = this.approveForRefill.bind(this);
        this.downloadCsv = this.downloadCsv.bind(this);
        this.toggleAllItems = this.toggleAllItems.bind(this);
        this.showRemoveFromAreaControlModal = this.showRemoveFromAreaControlModal.bind(this);
        this.hideRemoveFromAreaControlModal = this.hideRemoveFromAreaControlModal.bind(this);
        this.removeFromAreaControl = this.removeFromAreaControl.bind(this);
    }

    handlePageChange(newPage) {
        this.props.changePage(newPage - 1);
    }

    toggleItemSelection(id) {
        let selectedItems = this.state.selectedItems;
        if(contains(selectedItems, id)) {
            delete selectedItems[id];
        } else {
            selectedItems[id] = id;
        }
        this.setState({
            selectedItems: selectedItems
        });
    }

    toggleAllItems() {
        if(Object.keys(this.state.selectedItems).length > 0) {
            this.clearSelectedItems();
        } else {
            let selectedItems = this.props.items.reduce((map, item) => {
                map[item.id] = item.id;
                return map;
            }, {});
            this.setState({
                selectedItems: selectedItems
            });
        }
    }

    toggleDropDownMenu() {
        this.setState(prevState => ({
            dropdownMenuOpen: !prevState.dropdownMenuOpen
        }));
    }

    showRemoveFromAreaControlModal() {
        if(Object.keys(this.state.selectedItems).length <= 0) {
            return;
        }

        this.setState({removeFromAreaControlModalVisible: true});
    }

    hideRemoveFromAreaControlModal() {
        this.setState({removeFromAreaControlModalVisible: false});
    }

    clearSelectedItems() {
        this.setState({
            selectedItems: {}
        });
    }

    removeFromAreaControl(itemIds) {
        this.props.removeFromAreaControl(itemIds);
        this.hideRemoveFromAreaControlModal();
        this.clearSelectedItems();
    }

    componentDidMount() {
        this.props.fetchModules();
        this.props.fetchAreaControlledItems();
    }

    componentDidUpdate(prevProps) {
        if(!isEqual(this.props.items, prevProps.items)) {
            this.clearSelectedItems();
        }
    }

    enableAreaControl() {
        const areaControlIdsToEnable = Object.keys(this.state.selectedItems);
        this.props.enableAreaControl(areaControlIdsToEnable);
    }

    disableAreaControl() {
        const areaControlIdsToDisable = Object.keys(this.state.selectedItems);
        this.props.disableAreaControl(areaControlIdsToDisable);
    }

    disapproveForRefill() {
        const areaControlIdsToDisapprove = Object.keys(this.state.selectedItems);
        this.props.disapproveForRefill(areaControlIdsToDisapprove);
    }

    approveForRefill() {
        const areaControlIdsToApprove = Object.keys(this.state.selectedItems);
        this.props.approveForRefill(areaControlIdsToApprove);
    }

    downloadCsv() {
        buildCsvDownloadUrl(this.props.query, this.props.filters).then((url) => {
            window.location = url;
        });
    }

    render() {
        return (
            <div className="animated fadeIn" style={{fontSize: 'small'}}>
                <RemoveFromAreaControlModal
                    visible={this.state.removeFromAreaControlModalVisible}
                    items={Object.values(this.state.selectedItems)}
                    onConfirm={this.removeFromAreaControl}
                    onCancel={this.hideRemoveFromAreaControlModal}/>
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Flächensteuerung</h4>
                        <div className="row">
                            <div className="col-lg-10">
                                <AreaControlFilter query={this.props.query}
                                                   filters={this.props.filters}
                                                   updateReplenishmentStatusFilter={this.props.updateReplenishmentStatusFilter}
                                                   updateStockStatusFilter={this.props.updateStockStatusFilter}
                                                   updateRefillStatusFilter={this.props.updateRefillStatusFilter}
                                                   updateQuery={this.props.updateQuery}
                                                   updateModuleFilter={this.props.updateModuleFilter}
                                                   modules={this.props.modules}/>
                            </div>
                            <div className="col-lg-2 pull-left">
                                <Dropdown isOpen={this.state.dropdownMenuOpen} toggle={this.toggleDropDownMenu} style={{marginTop:'29px'}}>
                                    <DropdownToggle caret>
                                        ...weitere Aktionen
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={this.enableAreaControl}>Nachschub aktivieren</DropdownItem>
                                        <DropdownItem onClick={this.disableAreaControl}>Nachschub deaktivieren</DropdownItem>
                                        <DropdownItem onClick={this.approveForRefill}>Refill freigeben</DropdownItem>
                                        <DropdownItem onClick={this.disapproveForRefill}>Refill sperren</DropdownItem>
                                        <DropdownItem onClick={this.downloadCsv}>CSV-Download</DropdownItem>
                                        <DropdownItem onClick={this.showRemoveFromAreaControlModal}><i className="fa fa-exclamation-triangle"></i>Flächensteuerung beenden</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.items.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <ItemList items={this.props.items}
                                          selectedItems={this.state.selectedItems}
                                          selectItem={this.toggleItemSelection}
                                          toggleAreaControl={this.props.toggleAreaControl}
                                          toggleAllItems={this.toggleAllItems}
                                          forceReplenishment={this.props.forceReplenishment}
                                          propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                          sortDirection={this.props.sortProperties.sortDirection}
                                          updateSortProperty={this.props.updateSortProperty}
                                          updateMinimumStockQuantity={this.props.updateMinimumStockQuantity}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <Pagination
                                    activePage={this.props.pagination.page + 1}
                                    itemsCountPerPage={this.props.pagination.pageSize}
                                    totalItemsCount={this.props.pagination.totalElements}
                                    pageRangeDisplayed={20}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 pull-left">
                                <Select
                                    name="pageSize"
                                    value={this.props.pagination.pageSize}
                                    onChange={(select) => this.props.setPageSize(select.value)}
                                    options={[
                                        {value: '25', label: '25'},
                                        {value: '50', label: '50'},
                                        {value: '100', label: '100'},
                                        {value: '200', label: '200'},
                                        {value: '1000', label: '1000'}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.items.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        items: state.areacontrol.get('areaControlledItems').toJS(),
        filters: state.areacontrol.get('filters').toJS(),
        query: state.areacontrol.get('query'),
        pagination: state.areacontrol.get('pagination').toJS(),
        modules: state.areacontrol.get('modules').toJS(),
        sortProperties: state.areacontrol.get('sortProperties').toJS()
    };
}

const ConnectedAreaControlOverviewManager = connect(mapStateToProps, {
    updateQuery,
    updateModuleFilter,
    changePage,
    setPageSize,
    toggleAreaControl,
    disableAreaControl,
    enableAreaControl,
    disapproveForRefill,
    approveForRefill,
    forceReplenishment,
    fetchAreaControlledItems,
    fetchModules,
    updateReplenishmentStatusFilter,
    updateStockStatusFilter,
    updateRefillStatusFilter,
    updateSortProperty,
    updateMinimumStockQuantity,
    removeFromAreaControl
})(AreaControlOverviewManager);

export default ConnectedAreaControlOverviewManager;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/AreaControlOverviewManager.js